"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.palette = void 0;

var _color = _interopRequireDefault(require("color"));

var palette = {
  primary: '#e83f40',
  primaryHover: "".concat((0, _color["default"])('#e83f40').lighten(0.2)),
  primaryPressed: "".concat((0, _color["default"])('#e83f40').darken(0.2)),
  primaryDegradate: '#e86b3f',
  primaryTransparent: '#fcabac',
  disabled: '#c5c1c1',
  "default": '#4a4a4a',
  link: '#4382e5',
  error: '#af0019',
  success: '#39a472',
  warning: '#e86b3f',
  black: '#000000',
  bobBlack: '#4a4a4a',
  grey: '#949494',
  lightGrey: '#c5c1c1',
  transparent: 'rgba(0,0,0,0)',
  white: '#ffffff',
  darkWhite: '#efefef',
  secondary: '#5fafc1',
  secondaryDegradate: '#3f9b9b',
  gradLight: '#009dc1',
  gradDark: '#78b5c2',
  green: '#227f94',
  gold: '#ffd000'
};
exports.palette = palette;